import script from "./HighlightSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./HighlightSettings.vue?vue&type=script&setup=true&lang=ts"

import "./HighlightSettings.vue?vue&type=style&index=0&id=4ffde150&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ffde150"]])

export default __exports__